import React from 'react';

import { SmallDroppableColumn } from './SmallDroppableColumn.jsx';

const SmallGroupedColumns = props => (
  <React.Fragment>
    {props.columns.map((column, index) => {
      const columnTiles = props.getTiles(column.id);

      return (
        <SmallDroppableColumn
          key={index}
          columnNumber={index}
          columnId={column.id}
          tiles={columnTiles}
        />
      );
    })}
  </React.Fragment>
);

export default SmallGroupedColumns;
